module.exports = __webpack_public_path__ + "img/discard_silo_img4.5b0a161f.jpeg";